import React, { Component } from "react";
import AntdTreeSelect, { TreeSelectProps } from "antd/lib/tree-select";
import PagePoint from "../page-point/pagePointEnhanced";
import { ConfigConsumer, ConfigConsumerEProps } from "../config-provider";
import "antd/lib/tree-select/style";

const { TreeNode, SHOW_ALL, SHOW_PARENT, SHOW_CHILD } = AntdTreeSelect;
type TreeNodeValue = string | number | string[] | number[];

interface FTSProps extends TreeSelectProps<TreeNodeValue> {
  forwardedRef?: any;
}
class FdxTreeSelect extends Component<FTSProps> {
  render() {
    const { forwardedRef, ...rest } = this.props;
    return <AntdTreeSelect ref={forwardedRef} {...rest} />;
  }
}

const TreeSelect: any = React.forwardRef((props: FTSProps, ref) => {
  return (
    <ConfigConsumer>
      {({ pagePoint }: ConfigConsumerEProps) =>
        pagePoint ? (
          <PagePoint
            compType="TreeSelect"
            {...props}
            render={eventprops => (
              <FdxTreeSelect {...props} forwardedRef={ref} {...eventprops} data-ui-role="TreeSelect"/>
            )}
          ></PagePoint>
        ) : (
          <FdxTreeSelect {...props} forwardedRef={ref} />
        )
      }
    </ConfigConsumer>
  );
});

TreeSelect.TreeNode = TreeNode;
TreeSelect.SHOW_ALL = SHOW_ALL;
TreeSelect.SHOW_PARENT = SHOW_PARENT;
TreeSelect.SHOW_CHILD = SHOW_CHILD;
export default TreeSelect;



// WEBPACK FOOTER //
// ./src/components/tree-select/index.tsx